import { render, staticRenderFns } from "./BPHeader.vue?vue&type=template&id=9d47e6f0&scoped=true"
import script from "./BPHeader.vue?vue&type=script&lang=js"
export * from "./BPHeader.vue?vue&type=script&lang=js"
import style0 from "./BPHeader.vue?vue&type=style&index=0&id=9d47e6f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d47e6f0",
  null
  
)

export default component.exports